//import { useContext } from "react";
//import { UserContext } from "../components/UserContext";

function Trans(string) {
   return string;
 // const { translation } = useContext(UserContext);
 // return translation && translation[string] ? translation[string] : string;
}
export default Trans;
